// extracted by mini-css-extract-plugin
export var SubmitBtn = "Grouporder-module--SubmitBtn--a74b8";
export var accSec = "Grouporder-module--accSec--50a93";
export var appointmentTxt = "Grouporder-module--appointmentTxt--9ab75";
export var bookingId = "Grouporder-module--bookingId--9f345";
export var btn = "Grouporder-module--btn--11612";
export var btncont = "Grouporder-module--btncont--c835d";
export var clubSec = "Grouporder-module--clubSec--13319";
export var darktext = "Grouporder-module--darktext--558be";
export var desc = "Grouporder-module--desc--4267e";
export var desc2 = "Grouporder-module--desc2--aa544";
export var details = "Grouporder-module--details--e3f82";
export var details2 = "Grouporder-module--details2--1f8c5";
export var head = "Grouporder-module--head--4297e";
export var head2 = "Grouporder-module--head2--4da6b";
export var imgoutline = "Grouporder-module--imgoutline--6fb1c";
export var learnmore = "Grouporder-module--learnmore--74c10";
export var noorder = "Grouporder-module--noorder--7e142";
export var noresultcontainer = "Grouporder-module--noresultcontainer--76413";
export var orderList = "Grouporder-module--orderList--3dfad";
export var ordercon = "Grouporder-module--ordercon--90f89";
export var orderstable = "Grouporder-module--orderstable--2a68a";
export var orderstablecontainer = "Grouporder-module--orderstablecontainer--36daa";
export var paratext = "Grouporder-module--paratext--1e1e1";
export var price = "Grouporder-module--price--7fbca";
export var reviewBtn = "Grouporder-module--reviewBtn--79d3d";
export var subs = "Grouporder-module--subs--f1da8";
export var trial = "Grouporder-module--trial--18bcf";